import { HeadsetIcon, Heading, Icon, Pane, Text, majorScale } from 'evergreen-ui'
import React, { FC } from 'react'

const PodcastComingSoon: FC = () => (
  <Pane display="flex" flexDirection="column" alignItems="center" padding={majorScale(6)} data-testid="PodcastComingSoon">
    <Icon icon={HeadsetIcon} size={40} color="muted" marginBottom={majorScale(2)}></Icon>
    <Heading size={600} marginBottom={majorScale(1)}>
      Coming Soon
    </Heading>
    <Text size={500} textAlign="center">
      We're working on bringing you podcasts. Check back soon!
    </Text>
  </Pane>
)

export default PodcastComingSoon
